import {
  SET_GENERAL_CALC_CONCRETE_STRENGTH,
  SET_GENERAL_CALC_CONCRETE_CONDITIONS,
  SET_REINFORCEMENT_PLATE,
  SET_REINFORCEMENT_EDGE,
  SET_REINFORCEMENT_TO_LIMIT,
  SET_REINFORCEMENT_LONG_TEMPERATURE,
  SET_REINFORCEMENT_SHORT_TEMPERATURE,
  SET_HOLE_CONDITIONS,
  SET_REINFORCEMENT_TENSION,
  SET_REINFORCEMENT_SHEAR,
  SET_DRILLING_CONDITIONS,

  SET_BOND_CONDITIONS,
  SET_REBAR_USING_ORILLING_AID,
  SET_REBAR_INSTALLATION_CONDITIONS,
  SET_REBAR_HOLE_CONDITIONS,
  SET_REBAR_SHORT_ITEM,
  SET_REBAR_LONG_ITEM,
  SET_REBAR_TEMPERATURE,
  SET_REINFORCEMENT_SERVICE_TEMPERATURE,
  SET_LIGHT_WEIGHT_CONCRETE,

  SET_CONCRETE_THICKNESS,

  SET_SERVICE_TEMPERATURE,
  SET_MASONRY_DEFINITION_TYPE,
  SET_MASONRY_TYPE,
  SET_MASONRY_COMPRESSIVE_STRENGTH,
  SET_MASONRY_IMAGE,
  SET_MASONRY_LENGTH,
  SET_MASONRY_WIDTH,
  SET_MASONRY_HEIGHT,

  SET_MASONRY_JOB_SITE_TEST_DESIGNATION,
  SET_MASONRY_JOB_SITE_TEST_NAME,
  SET_MASONRY_JOB_SITE_TEST_SIZE,
  SET_MASONRY_JOB_SITE_TEST_CONSTRUCTION_WORK,
  SET_MASONRY_JOB_SITE_TEST_BUILDING_OWNER,
  SET_MASONRY_JOB_SITE_TEST_DATE_OF_TESTS,
  SET_MASONRY_JOB_SITE_TEST_PLACE_OF_TESTS,
  SET_MASONRY_JOB_SITE_TEST_TYPE_OF_STRUCTURE_TO_BE_FIXED,

  SET_MASONRY_JOB_SITE_TEST_TESTS_CARRIED_OUT_BY,
  SET_MASONRY_JOB_SITE_TEST_TESTS_SUPERVISED_BY,
  SET_MASONRY_JOB_SITE_TEST_DIAMETER_OF_HAMMER_DRILL_BITS,
  SET_MASONRY_JOB_SITE_TEST_DRILLING_DEPTH,
  SET_MASONRY_JOB_SITE_TEST_EMBEDMENT_DEPTH,
  SET_MASONRY_JOB_SITE_TEST_REF_TEST_RING,
  SET_MASONRY_JOB_SITE_TEST_INSTALLATION_PROCESS_ACCORDING_TO,

  ADD_MASONRY_RESULT,
  UPDATE_MASONRY_RESULT, REMOVE_MASONRY_RESULT,
  RESET_MATERIAL_STATE,
  SET_MATERIAL_STATE,
  SET_WOOD_STRENGTH_CLASS,
  SET_CUSTOM_WOOD_STRENGTH
} from './actions';
import { APP_TYPES } from '@config';
import { mergeDeep } from '@services/helper.service';
import { TABS as MasonryTabs } from './../../../views/Material/components/Masonry';

export const initState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    concrete: {
      strength: "0",
      customValue: null,
      conditions: "0",
      thicknessOfConcrete: 200,
      lightWeightConcrete: {
        active: false,
        lambda: 1.00
      }
    },
    reinforcementAndConditions: {
      plate: '',
      edge: '',
      tension: 0,
      shear: 0,
      reinforcementToLimit: true,
      longTemperature: 24,
      shortTemperature: 40,
      serviceTemperature: 44,
      holeConditions: '0',
      drillingConditions: '0'
    },
    serviceTemperature: {
      value: 24
    },
    masonry: {
      masonryDefinitionType: MasonryTabs.SPIT_TECH,
      characteristicsMasonryUnits: {
        masonryType: '',
        imageLink: '',
        compressiveStrength: 0,
        length: 0,
        width: 0,
        height: 0
      },
      jobSiteTest: {
        designation: '',
        productName: '',
        size: '',
        details: {
          constructionWork: '',
          buildingOwner: '',
          dateOfTests: '',
          placeOfTests: '',
          typeOfStructureToBeFixed: ''
        },
        execution: {
          testsCarriedOutBy: '',
          testsSupervisedBy: '',
          diameterOfHammerDrillBits: 0,
          drillingDepth: 0,
          embedmentDepth: 0,
          refTestRing: '',
          installationProcessAccordingTo: 1
        },
        results: [{
          id: 1,
          tensile: 0,
          shear: 0
        },{
          id: 2,
          tensile: 0,
          shear: 0
        },{
          id: 3,
          tensile: 0,
          shear: 0
        },{
          id: 4,
          tensile: 0,
          shear: 0
        },{
          id: 5,
          tensile: 0,
          shear: 0
        }]
      }
    }
  },

  [APP_TYPES.BRACKET_ATTACHMENT]: {
    concrete: {
      strength: "0",
      customValue: null,
      conditions: "0",
      thicknessOfConcrete: 200,
      lightWeightConcrete: {
        active: false,
        lambda: 1.00
      }
    },
    reinforcementAndConditions: {
      plate: '',
      edge: '',
      tension: 0,
      shear: 0,
      reinforcementToLimit: true,
      longTemperature: 24,
      shortTemperature: 40,
      serviceTemperature: 24,
      holeConditions: '0',
      drillingConditions: '0'
    }
  },

  [APP_TYPES.SAFETY_BARRIER]: {
    concrete: {
      strength: "0",
      customValue: null,
      conditions: "0",
      thicknessOfConcrete: 200,
      lightWeightConcrete: {
        active: false,
        lambda: 1.00
      }
    },
    reinforcementAndConditions: {
      plate: '',
      edge: '',
      tension: 0,
      shear: 0,
      reinforcementToLimit: true,
      longTemperature: 24,
      shortTemperature: 40,
      serviceTemperature: 24,
      holeConditions: '0',
      drillingConditions: '0'
    }
  },

  [APP_TYPES.REBAR_REINFORCEMENT]: {
    concrete: {
      strength: "0",
      customValue: null,
      thicknessOfConcrete: 200,
      bondConditions: '0'
    },
    drillingAndTemperature: {
      temperature: '',
      longItem: 24.00,
      shortItem: 40.00,
      installationConditions: '0',
      holeConditions: '0',
      usingDrillingAid: false
    }
  },

 [APP_TYPES.WOOD_CONNECTION]: {
    concrete: {
      strength: null,
      conditions: null,
      bondConditions: null,
      thicknessOfConcrete: 200,
      lightWeightConcrete: {
        active: false,
        lambda: 0.85
      }
    },
    reinforcementAndConditions: { 
      plate: '',
      edge: '',
      tension: 0,
      shear: 0,
      reinforcementToLimit: false,
      longTemperature: 24,
      shortTemperature: 40,
      serviceTemperature: 44,
      holeConditions: '0',
      drillingConditions: '0'
    },
    wood: {
      woodStrengthClass: 'C18',
      customWoodStrength: 320
    }
  }
};

const dimension = (state = initState, action) => {
  switch (action.type) {
    case SET_GENERAL_CALC_CONCRETE_STRENGTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          concrete: {
            strength: action.value,
            customValue: action.customValue || null
          }
        }
      });
    }
    case SET_GENERAL_CALC_CONCRETE_CONDITIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          concrete: {
            conditions: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_PLATE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            plate: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_EDGE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            edge: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_TO_LIMIT: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            reinforcementToLimit: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_LONG_TEMPERATURE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            longTemperature: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_SHORT_TEMPERATURE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            shortTemperature: action.value
          }
        }
      });
    }
    case SET_HOLE_CONDITIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            holeConditions: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_TENSION: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            tension: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_SHEAR: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            shear: action.value
          }
        }
      });
    }
    case SET_DRILLING_CONDITIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            drillingConditions: action.value
          }
        }
      });
    }
    case SET_REINFORCEMENT_SERVICE_TEMPERATURE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          reinforcementAndConditions: {
            serviceTemperature: action.value
          }
        }
      });
    }

    case SET_BOND_CONDITIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          concrete: {
            bondConditions: action.value
          }
        }
      });
    }

    case SET_REBAR_TEMPERATURE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          drillingAndTemperature: {
            temperature: action.value
          }
        }
      });
    }
    case SET_REBAR_LONG_ITEM: {
      return mergeDeep({}, state, {
        [action.appType]: {
          drillingAndTemperature: {
            longItem: action.value
          }
        }
      });
    }
    case SET_REBAR_SHORT_ITEM: {
      return mergeDeep({}, state, {
        [action.appType]: {
          drillingAndTemperature: {
            shortItem: action.value
          }
        }
      });
    }
    case SET_REBAR_INSTALLATION_CONDITIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          drillingAndTemperature: {
            installationConditions: action.value
          }
        }
      });
    }
    case SET_REBAR_HOLE_CONDITIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          drillingAndTemperature: {
            holeConditions: action.value
          }
        }
      });
    }
    case SET_REBAR_USING_ORILLING_AID: {
      return mergeDeep({}, state, {
        [action.appType]: {
          drillingAndTemperature: {
            usingDrillingAid: action.value
          }
        }
      });
    }
    case SET_LIGHT_WEIGHT_CONCRETE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          concrete: {
            lightWeightConcrete: {
              active: action.active,
              lambda: action.value || 0
            }
          }
        }
      });
    }
    case SET_CONCRETE_THICKNESS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          concrete: {
            thicknessOfConcrete: action.value
          }
        }
      });
    }
    case SET_SERVICE_TEMPERATURE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          serviceTemperature: {
            value: action.value
          }
        }
      });
    }
    case SET_MASONRY_DEFINITION_TYPE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            masonryDefinitionType: action.value
          }
        }
      });
    }
    case SET_MASONRY_TYPE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            characteristicsMasonryUnits: {
            masonryType: action.value
          }
        }
        }
      });
    }
    case SET_MASONRY_COMPRESSIVE_STRENGTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            characteristicsMasonryUnits: {
              compressiveStrength: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_IMAGE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            characteristicsMasonryUnits: {
              imageLink: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_LENGTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            characteristicsMasonryUnits: {
              length: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_WIDTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            characteristicsMasonryUnits: {
              width: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_HEIGHT: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            characteristicsMasonryUnits: {
              height: action.value
            }
          }
        }
      });
    }

    case SET_MASONRY_JOB_SITE_TEST_DESIGNATION: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              designation: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_NAME: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              productName: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_SIZE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              size: action.value
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_CONSTRUCTION_WORK: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              details: {
                constructionWork: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_BUILDING_OWNER: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              details: {
                buildingOwner: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_DATE_OF_TESTS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              details: {
                dateOfTests: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_PLACE_OF_TESTS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              details: {
                placeOfTests: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_TYPE_OF_STRUCTURE_TO_BE_FIXED: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              details: {
                typeOfStructureToBeFixed: action.value
              }
            }
          }
        }
      });
    }

    case SET_MASONRY_JOB_SITE_TEST_TESTS_CARRIED_OUT_BY: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                testsCarriedOutBy: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_TESTS_SUPERVISED_BY: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                testsSupervisedBy: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_DIAMETER_OF_HAMMER_DRILL_BITS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                diameterOfHammerDrillBits: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_DRILLING_DEPTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                drillingDepth: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_EMBEDMENT_DEPTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                embedmentDepth: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_REF_TEST_RING: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                refTestRing: action.value
              }
            }
          }
        }
      });
    }
    case SET_MASONRY_JOB_SITE_TEST_INSTALLATION_PROCESS_ACCORDING_TO: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              execution: {
                installationProcessAccordingTo: action.value
              }
            }
          }
        }
      });
    }
    case SET_WOOD_STRENGTH_CLASS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          wood: {
            woodStrengthClass: action.value
          }
        }
      });
    }
    case SET_CUSTOM_WOOD_STRENGTH: {
       return mergeDeep({}, state, {
         [action.appType]: {
          wood: {
            customWoodStrength: action.value
          }
         }
       });
    }
    case ADD_MASONRY_RESULT: {
      const {results} = state[action.appType].masonry.jobSiteTest;
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              results: [...results, {
                id: results.length + 1 + new Date().getTime(),
                tensile: 0,
                shear: 0
              }]
            }
          }
        }
      });
    }
    case UPDATE_MASONRY_RESULT: {
      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              results: state[action.appType].masonry.jobSiteTest.results.map((item, index) => {
                if (index === action.index)
                  return mergeDeep({}, item, action.value);
                else 
                  return item;
              })
            }
          }
        }
      });
    }
    case REMOVE_MASONRY_RESULT: {
      const { results } = state[action.appType].masonry.jobSiteTest;

      return mergeDeep({}, state, {
        [action.appType]: {
          masonry: {
            jobSiteTest: {
              results: results.filter(i => action.toRemove.indexOf(i.id) < 0)
            }
          }
        }
      });
    }
    case RESET_MATERIAL_STATE: {
      return mergeDeep({}, state,  {
        [action.appType]: mergeDeep({}, initState[action.appType])
      });
    }    
    case SET_MATERIAL_STATE: {
      return action.state;
    }
    default: {
      return state;
    }
  }
};

export default dimension;



// WEBPACK FOOTER //
// ./src/reducers/selectors/material/index.js